export enum ThresholdType {
  CASES = 'CS',
  LBS = 'LBS'
}
